export const CommonConfig = {
    HERE_MAP_ID: 'mVwOXuhEwBUASbVnUS7f',
    HERE_MAP_CODE: 'mU0PAOyk7DAUf8rCCRTpRA',
    AUTO_TIMEOUT: 20000,
    PAGE_LOADING: "",
    ORDER_SEARCH_TIMEOUT: 1000,
    ITEM_SEARCH_TIMEOUT: 500,
    LOCATION_SEARCH_TIMEOUT: 500,
    mapConfig:{}
}
